import React from 'react';
import { useTranslation } from "react-i18next";
import { Link, NavLink } from 'react-router-dom';
import iconHistory from '../assets/footer-history.png';
import iconBids from '../assets/footer-bids.png';
import iconHome from '../assets/footer-home.png';
import iconWallet from '../assets/footer-wallet.png';
import iconWebsite from '../assets/footer-website.png';
import './Footer.css';

// The PNG is used as a mask so the icon takes the tab's text colour
const FooterTabIcon = ({ src }) => (
  <div className="footer-icon-bubble" aria-hidden="true">
    <div className="footer-icon-img" style={{ '--icon': `url(${src})` }} />
  </div>
);

const tabClass = (extra = '') => ({ isActive }) =>
  `footer-icon ${extra} ${isActive ? 'active' : ''}`;

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="sticky-footer">
      <nav className="footer-content">
        <NavLink to={'/account-statement'} className={tabClass()}>
          <FooterTabIcon src={iconHistory} />
          <span className="footer-label">{t('footer.history')}</span>
        </NavLink>
        <NavLink to={'/all-bid'} className={tabClass()}>
          <FooterTabIcon src={iconBids} />
          <span className="footer-label">{t('footer.allBids')}</span>
        </NavLink>
        <NavLink to={'/home'} className={tabClass('footer-icon--home')}>
          <FooterTabIcon src={iconHome} />
          <span className="footer-label">{t('footer.home')}</span>
        </NavLink>
        <NavLink to={'/wallet_histroy'} className={tabClass()}>
          <FooterTabIcon src={iconWallet} />
          <span className="footer-label">{t('footer.wallet')}</span>
        </NavLink>
        <Link to={'https://dpbossl.com/?type=URL_FOR_WEBSITE'} target='_blank' rel="noopener noreferrer" className="footer-icon">
          <FooterTabIcon src={iconWebsite} />
          <span className="footer-label">{t('footer.website')}</span>
        </Link>
      </nav>
    </footer>
  );
};

export default Footer;
